<template>
  <div class="top_btns">
    <i-row style="margin-bottom: 8px;">
      <i-col span="12">
        <!-- メインメニューボタン Drwar -->
        <MainMenu style="margin-right: 4px;" />
        <i-button type="primary" size="small" icon="ios-settings" style="margin-right: 4px;" @click="_setting = true">
          設定
        </i-button>
      </i-col>
      <i-col span="12" style="text-align: right;">
        <BtnFontSize :fontSize.sync="_fontSize" />
      </i-col>
    </i-row>
    <i-row style="margin-bottom: 8px;">
      <i-col span="24">
        <i-button type="primary" size="small" ghost style="margin-right: 4px;" @click="onClickNewProperty">
          物件新規追加
        </i-button>
        <i-button type="primary" size="small" icon="ios-browsers-outline" @click="_convert = true">
          コンバート一覧・結果
        </i-button>
      </i-col>
    </i-row>
  </div>
</template>

<script>
import { Row, Col, Button } from 'view-design'
import MainMenu from '@/components/globals/MainMenu'
import BtnFontSize from '@/components/parts/BtnFontSize'
export default {
  components: {
    'i-row': Row,
    'i-col': Col,
    'i-button': Button,
    MainMenu,
    BtnFontSize,
  },
  props: {
    setting: {
      type: Boolean,
      default: false,
    },
    convert: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: Number,
      default: null,
    },
    tab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.getters['User/getUser']
    },
    _setting: {
      get() {
        return this.setting
      },
      set(val) {
        this.$emit('update:setting', val)
      },
    },
    _convert: {
      get() {
        return this.convert
      },
      set(val) {
        this.$emit('update:convert', val)
      },
    },
    _fontSize: {
      get() {
        return this.fontSize
      },
      set(val) {
        this.$emit('update:fontSize', val)
      },
    },
  },
  methods: {
    onClickNewProperty() {
      this.$store.dispatch('ModalNewPropertyLinkList/set', { tab: this.tab })
    },
  },
}
</script>

<style lang="scss" scoped></style>
